/* globals FullCalendar */

import $ from 'jquery';
import showTemplateFlash from '../util/show_template_flash';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  let calendar;
  if ($('body').is('#calendar')) {
    document.addEventListener('DOMContentLoaded', () => {
      const projectId = $('meta[name="project-id"]').attr('content');
      const calendarEl = document.getElementById('fullcalendar-container');
      calendar = new FullCalendar.Calendar(calendarEl, {
        eventResizableFromStart: true,
        height: 'auto',
        timeZone: $('meta[name=time-zone]').attr('content'),
        initialView: 'dayGridMonth',
        initialDate: $('meta[name="initial-date"]').attr('content'),
        fixedWeekCount: false,
        nowIndicator: true,
        showNonCurrentDates: false,
        dayMaxEvents: 4,
        headerToolbar: {
          left: '',
          center: 'prev title next',
          right: 'today dayGridMonth,timeGridWeek,timeGridDay',
        },
        dayHeaderFormat: { weekday: 'long' },
        views: {
          dayGrid: {
            titleFormat: { year: 'numeric', month: 'long' },
          },
        },
        dateClick: (info) => {
          $.get(
            `/projects/${projectId}/calendar_events/new`,
            { date: info.dateStr, all_day: info.allDay },
            (html) => {
              $(html).appendTo('body').modal();
            }
          );
        },
        dayCellDidMount(cell) {
          const $addEventLink = $('<span class="add-calendar-event-link hide">+ Add Event</span>');
          $(cell.el).mouseenter((e) => {
            $(e.currentTarget).find('.fc-daygrid-day-top').append($addEventLink);
          });
          $(cell.el).mouseleave((e) => {
            $addEventLink.remove();
          });
          $(cell.el).mouseover((e) => {
            const $target = $(e.target);
            const $calendrEvents = $target.parents('.fc-daygrid-day-events');
            const isDayBottom = $target.hasClass('fc-daygrid-day-bottom');
            if ($target.hasClass('add-calendar-event-link')) {
              e.stopPropagation();
            }
            $addEventLink.toggle(isDayBottom || $calendrEvents.length === 0);
          });
        },
        datesSet: ({ startStr }) => {
          const newUrl = `${window.location.pathname}?start_date=${startStr.split('T')[0]}`;
          window.history.replaceState(null, '', newUrl);
        },
        eventMouseEnter(info) {
          $(info.el).attr('title', info.event.title);
        },
        events: `/projects/${projectId}/calendar/xhr_calendar_events`,
        eventClassNames: (info) => {
          const classNames = [];
          if (info.event.extendedProps.is_yesterday === true) {
            classNames.push('fc-event-past');
          }
          if (
            info.event.extendedProps.kind === 'task_event' &&
            info.event.extendedProps.is_completed === true
          ) {
            classNames.push('fc-event-completed');
          }
          return classNames;
        },
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          meridiem: 'short',
        },
        eventDisplay: 'block',
        eventOrder: (event) => {
          return event.kind === 'project_due_date' ? 1 : 0;
        },
        moreLinkContent: (args) => {
          return args.num === 1 ? '+ 1 more item' : `+ ${args.num} more items`;
        },
        eventClick: (info) => {
          info.jsEvent.preventDefault();
          if (info.event.extendedProps.kind === 'project_due_date') {
            return;
          } else if (info.event.extendedProps.kind === 'task_event') {
            window.open(info.event.url);
          } else {
            $.get(info.event.url, (html) => {
              $('.fc-popover-close').click();
              $(html).appendTo('body').modal();
            });
          }
        },
        eventDrop: (info) => {
          updateDraggedOrResizedEvent(info);
        },
        eventResize: (info) => {
          updateDraggedOrResizedEvent(info);
        },
      });
      calendar.render();
    });
  }

  const roundUpTime = (time) => {
    // A typed value such as "3pm" has no minutes to round.
    if (!/^\d{1,2}:\d{2}/.test(time)) {
      return time;
    }

    const defaultHours = parseInt(time.split(':')[0]);
    const defaultMinutes = parseInt(time.split(':')[1]);
    const meridiem = time.split(':')[1].replace(/\d+/g, '');
    const roundedMinutes = Math.ceil(defaultMinutes / 15) * 15;
    if (roundedMinutes === 0) {
      return time;
    } else {
      return `${defaultHours}:${roundedMinutes}${meridiem}`;
    }
  };

  const initTimepicker = (field) => {
    // round up time only on initial selection
    const defaultTime = field.data('id') ? field.data('time') : roundUpTime(field.val());

    field.timepicker({
      zindex: 501,
      timeFormat: 'h:mmp',
      interval: 15,
      defaultTime,
      startTime: '00:00',
      dynamic: false,
      dropdown: true,
      scrollbar: true,
      change: (time) => {
        $(field).on('click', () => {
          field.closest('form').find('.error-message').hide();
          scrollSelectionIntoView(field);
        });

        if (
          $('.field--calendar-event-start-date').datepicker('getDate') === null ||
          !field.hasClass('field--calendar-event-starts-at-time') ||
          !time
        ) {
          return;
        }

        const startTime = time.toTimeString();
        const startDate = $('.field--calendar-event-start-date')
          .datepicker('getDate')
          .toDateString();
        const eventStartAt = new Date(`${startDate} ${startTime}`);
        const thirtyMinutesFromNow = new Date(
          new Date(Date.now() + 1000 * (60 * 30)).toLocaleString('en', {
            timeZone: $('.calendar-event-form').attr('data-time-zone'),
          })
        );
        // disable reminder if the event start after the soonest reminder as 30 minutes before
        $('.field--reminder').prop('disabled', eventStartAt < thirtyMinutesFromNow);
      },
    });
  };

  const scrollSelectionIntoView = (field) => {
    $('.ui-state-hover').removeClass('ui-state-hover');
    // find selected item in the dropdown
    if (!field.val()) {
      return;
    }

    const dropdownSelection = $('.ui-timepicker .ui-menu-item').filter(function () {
      return $(this).text() === roundUpTime(field.val());
    });

    // highlight selected item
    dropdownSelection.find('.ui-corner-all').addClass('ui-state-hover');

    // scroll to selected item
    const index = dropdownSelection.index();
    const height = dropdownSelection.innerHeight();

    $('.ui-timepicker-viewport').scrollTop(index * height);
  };

  const updateCalendar = (data) => {
    $.modal.close();

    const event = calendar
      .getEvents()
      .find((e) => e.extendedProps.event_id === data.event.event_id);
    if (data.action === 'create') {
      calendar.refetchEvents();
    } else if (data.action === 'update') {
      updateCalendarEvent(event, data.event);
    } else if (data.action === 'destroy') {
      event.remove();
    }

    showFlashMessage(data.notice);
  };

  const updateCalendarEvent = (event, eventInfo) => {
    event.setProp('title', eventInfo.title);
    event.setAllDay(eventInfo.allDay);
    event.setStart(eventInfo.start);
    event.setEnd(eventInfo.end);
    event.setExtendedProp('is_yesterday', eventInfo.is_yesterday);
  };

  const updateDraggedOrResizedEvent = (info) => {
    const { oldEvent, event: updatedEvent } = info;
    const kind = updatedEvent.extendedProps.kind;

    if (kind === 'custom_event' || updatedEvent.allDay) {
      $.ajax({
        url: updatedEvent.extendedProps.update_dragged_or_resized_event_url,
        type: 'PATCH',
        data: { calendar_event: calendarEventParams(kind, oldEvent, updatedEvent) },
      }).done(() => {
        calendar.refetchEvents();
      });
    } else {
      info.revert(); // revert if other than custom event is dragged into hour cell
    }
  };

  const calendarEventParams = (kind, oldEvent, updatedEvent) => {
    if (kind === 'custom_event') {
      return customEventParams(oldEvent, updatedEvent);
    } else if (['project_due_date', 'task_event'].includes(kind)) {
      return { new_due_date: updatedEvent.startStr };
    } else {
      return { old_date: oldEvent.startStr, new_date: updatedEvent.startStr };
    }
  };

  const customEventParams = (oldEvent, updatedEvent) => {
    let endsAt;
    if (oldEvent.allDay) {
      if (updatedEvent.allDay) {
        endsAt = new Date(updatedEvent.end.getTime() - 24 * 60 * 60 * 1000); // subtract one day for exclusive end time
      } else {
        endsAt = new Date(updatedEvent.start.getTime() + 60 * 60 * 1000); // add one hour to start time
      }
    } else {
      endsAt = updatedEvent.allDay ? updatedEvent.startStr : updatedEvent.endStr;
    }
    return {
      starts_at: updatedEvent.startStr,
      ends_at: endsAt,
      all_day: updatedEvent.allDay,
    };
  };
  const showFlashMessage = (message) => {
    if (document.body.hasAttribute('data-sidenav-layout')) {
      showTemplateFlash('calendar-notice', message);

      return;
    }

    $('.flash--notice').remove();
    const $flash = $(`<div class="flash flash--notice">${message}</div>`);
    $('.main').prepend($flash);

    setTimeout(() => {
      $flash.fadeOut('slow', () => $flash.remove());
    }, 5000);
  };

  $(function () {
    $(document).on($.modal.OPEN, '.modal--calendar-event-form', () => {
      $('.field--calendar-event-start-date, .field--calendar-event-end-date').datepicker();

      initTimepicker($('.field--calendar-event-starts-at-time'));
      initTimepicker($('.field--calendar-event-ends-at-time'));

      $(document).on($.modal.CLOSE, '.modal--calendar-event-form', (e) => {
        // make sure time picker dropdown is hidden when modal closes
        $('.ui-timepicker-container').hide();

        $(e.target).remove();
      });
    });

    $(document).on('change', '.calendar-event-all-day-checkbox', (e) => {
      if ($(e.target).prop('checked')) {
        $('.field--calendar-event-starts-at-time').hide();
        $('.field--calendar-event-ends-at-time').hide();
      } else {
        $('.field--calendar-event-starts-at-time').show();
        $('.field--calendar-event-ends-at-time').show();
      }
    });

    $(document).on(
      'keyup paste change',
      '.field--calendar-event-title, .field--calendar-event-start-date, .field--calendar-event-end-date',
      (e) => {
        $(e.target).closest('form').find('.error-message').hide();
      }
    );

    $(document).on('submit', '.calendar-event-form', (e) => {
      e.preventDefault();
      const $form = $(e.target);
      const $submitButton = $form.find('.p-button--save-calendar-event');
      const projectId = $('meta[name="project-id"]').attr('content');
      let validationUrl;

      if ($form.find('input[name=_method]').val() === 'patch') {
        const calendarEventId = $form.attr('action').split('/').at('-1');
        validationUrl = `/projects/${projectId}/calendar_events/${calendarEventId}/xhr_validate_calendar_event`;
      } else {
        validationUrl = `/projects/${projectId}/calendar_events/xhr_validate_calendar_event`;
      }

      $.post(validationUrl, $form.serialize().replace('_method=patch', '_method=post'), (data) => {
        if (data.valid) {
          // continue submitting form
          $.post($form.attr('action'), $form.serialize(), (eventData) => {
            updateCalendar(eventData);
          });
        } else {
          const errorSpanClasses = {
            title: 'error-message--calendar-event-title',
            starts_at: 'error-message--calendar-event-start-date',
            ends_at: 'error-message--calendar-event-end-date',
          };
          const errors = data.errors;
          for (const key in data.errors) {
            const $errorSpanSelector = $form.find(`.${errorSpanClasses[key]}`);
            if ($errorSpanSelector) {
              $errorSpanSelector.text(errors[key]).show();
            }
          }
          $submitButton.prop('disabled', false);
        }
      });
    });
  });

  $(document).on('click', '.delete-calendar-event', (e) => {
    $('.calendar-event-form-actions').hide();
    $('.calendar-event-form__confirm-delete').show();
  });

  $(document).on('click', '.calendar-event-form__keep-calendar-entry', (e) => {
    $('.calendar-event-form__confirm-delete').hide();
    $('.calendar-event-form-actions').show();
  });

  $(document).on('ajax:success', '.d-button--delete-calendar-entry', (_, data) => {
    updateCalendar(data);
  });

  $(document).on('change', '.field--calendar-event-start-date', () => {
    $('.field--calendar-event-starts-at-time').trigger('change');
  });
});
